var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 pl-5 pr-5",attrs:{"cols":"12"}},[_c('v-sheet',{attrs:{"rounded":"lg"}},[_c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Tipos de Pontos de Venda")]),_c('paragrafo',[_vm._v("Nesta opção serão incluídos os tipos de Pontos de Venda.")]),_c('imagem',{attrs:{"src":_vm.image_2}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }